import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

interface ModerationSwitchProps {
  /** On: the user's orders wait for an admin (manual moderation). */
  checked: boolean;
  disabled?: boolean;
  ariaLabel: string;
  onToggle: () => void;
}

/**
 * The switch of the ASA platform's tables (CampaignsTable): 36×20 with a 16px
 * knob, brand when on. A click in a table row does not reach the row.
 */
const ModerationSwitch: React.FC<ModerationSwitchProps> = ({
  checked,
  disabled,
  ariaLabel,
  onToggle,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    className={cn(styles.switch, { [styles.switchOn]: checked })}
    onClick={(e) => {
      e.stopPropagation();
      onToggle();
    }}
  >
    <span className={styles.switchKnob} />
  </button>
);

export default ModerationSwitch;
